<template>
    <div class="ultimas-publicacoes">
        <h1>Últimas publicações</h1>

        <div class="ultimas-publicacoes-container" v-if="!mobile">
            <div flex class="spinner" v-if="loading">
                <b-spinner variant="primary" label="Spinning"></b-spinner>
            </div> 
            <div class="ultimas-publicacoes-card" v-for="ultimapublicao in ultimasPublicacoes">
                <img v-bind="publicacoesImgProperties" :src="ultimapublicao.thumbnail" >
                <h2 v-html="ultimapublicao.title"></h2>
                <p v-html="ultimapublicao.excerpt"></p>
                <b-link class="ultimas-publicacoes-saibamais" target="_blank" :href="ultimapublicao.href">Saiba mais<div class="ultimas-publicacoes-saibamais-arrow"></div></b-link>
            </div>
        </div>
        <div v-else class="ultimas-publicacoes-carrousel">
            <div flex class="spinner" v-if="loading">
                <b-spinner variant="primary" label="Spinning"></b-spinner>
            </div> 
            <b-carousel ref="ultimasPublicacoesCarousel" v-bind="ultimasPublicacoesCarouselProperties">
            <b-carousel-slide v-for="ultimapublicao in ultimasPublicacoes">
                <div class="ultimasPublicacoesCarousel-elements">
                    <img v-bind="publicacoesImgProperties" :src="ultimapublicao.thumbnail" >
                    <h2 v-html="ultimapublicao.title"></h2>
                    <p v-html="ultimapublicao.excerpt"></p>
                    <b-link class="ultimas-publicacoes-saibamais" :href="ultimapublicao.href">Saiba mais<div class="ultimas-publicacoes-saibamais-arrow"></div></b-link>
                </div>
            </b-carousel-slide>
        </b-carousel>
        </div>
    </div>
</template>
<script>
import API from "../../services/api";

export default {
    data() {
      return {
        mobile:  window.innerWidth < 1200,
        loading: false,
        publicacoesImgProperties: {
            center: true,
            fluidGrow: true,
            height: 186,
            width: 320,
            style: {
                'margin-bottom': '18px',
                'border-radius': '5px'
            }
        },
        ultimasPublicacoesCarouselProperties:{
                controls: false,
                indicators: true,
                interval: 0,
        },
        ultimasPublicacoes: [],
        saibaMaisIconProperties: {
            style: {
                height: '20px',
                width: '20px',
            }
        },
      }
    },
    beforeDestroy () {
        if (typeof window !== 'undefined') {
        window.removeEventListener('resize', this.onResize, { passive: true })
        }
    },
    mounted () {
        this.onResize()
        window.addEventListener('resize', this.onResize, { passive: true })
    },
    created(){
        let perPage = 3;
        let page = 1;
        this.loadPostList(perPage,page);
    },
    methods: {
        getPublicacaoThumbnail(thumbnail) {
            var images = require.context('../../assets/imgs/', false, /\.png$/);
            return images('./' + thumbnail)
        },
        onResize () {
            this.isMobile = window.innerWidth < 600
        },
        async loadPostList(perPage, page){
            let self = this;
            self.loading = true;
            let dados = {
                filters:{
                    per_page: perPage,
                    page: page,
                }
            };
            API.post('/blog/post-list', dados).then((res) => {
                let data = res.data;
                if(data.code === 200){
                    let postList = data.response;
                    for (let index = 0; index < postList.length; index++) {
                        let post = {
                            excerpt: this.cleanExcerpt(postList[index].excerpt),
                            href: postList[index].href,
                            thumbnail: postList[index].thumbnail,
                            title: postList[index].title,
                        };
                        this.ultimasPublicacoes.push(post);
                    }
                    self.loading = false;
                }
                else{
                    console.log('Erro desconhecido ao carregar lista de posts!');
                }
            }).catch((error) => {
                console.log('Erro ao carregar lista de posts!' + error);
            });
        },
        cleanExcerpt(excerpt){
            let cleanExcerpt = excerpt.substring(
                excerpt.indexOf("<p>") + 3, 
                excerpt.indexOf("</p>")
            );
            return cleanExcerpt;
        }
    }
}
</script>
<style scoped>
    .ultimas-publicacoes{
        background: #F1F1F1 0% 0% no-repeat padding-box;
        width: 100%;
        padding-top: 104px;
        padding-bottom: 123px;
    }
    .ultimas-publicacoes h1{
       text-align: center;
        font: normal normal bold 25px/41px 'Kanit', sans-serif;
        letter-spacing: 0px;
        color: #597EB5;
        text-transform: none;
        margin-bottom: 64px;
    }
    .ultimas-publicacoes .ultimas-publicacoes-container{
        display: flex;
        margin: 0 auto;
        width:fit-content;

    }
    .ultimas-publicacoes .spinner {
        width: 130px;
        height: 130px;
        justify-content: center;
        align-items: center;
        display: flex;
        margin: 0 auto;
    }
    .ultimas-publicacoes .spinner .text-primary{
        color:#4780F1 !important;
    }
    .ultimas-publicacoes .spinner .spinner-border{
        width: 100%;
        height: 100%;
    }
    .ultimas-publicacoes .ultimas-publicacoes-container .ultimas-publicacoes-card:not(:last-child){
        margin-right: 57px;
    }
    .ultimas-publicacoes .ultimas-publicacoes-container .ultimas-publicacoes-card{
        display: flex;
        flex-flow: column;
        width: 320px;

    }
    .ultimas-publicacoes .ultimas-publicacoes-container .ultimas-publicacoes-card h2{
        text-align: left;
        font: normal normal bold 18px/22px 'Kanit', sans-serif;
        letter-spacing: 0px;
        color: #707070;
        text-transform: none;
        margin-bottom: 18px;
        height: 66px;
    }
    .ultimas-publicacoes .ultimas-publicacoes-container .ultimas-publicacoes-card p{
        text-align: left;
        font: normal normal normal 15px/20px 'Kanit', sans-serif;
        letter-spacing: 0px;
        color: #707070;
        text-transform: none;
        margin-bottom: 21px;
        height: 60px;
        overflow: hidden;
        width: 100%;
        position: relative;
    }
    .ultimas-publicacoes .ultimas-publicacoes-container .ultimas-publicacoes-card p:before {
        content: "";
        text-align: right;
        position: absolute;
        bottom: 0;
        right: 0;
        width: 41%;
        height: 20px;
        background: linear-gradient(to right, #f1f1f100 , #F1F1F1 50%);
    }
    .ultimas-publicacoes .ultimas-publicacoes-container .ultimas-publicacoes-card .ultimas-publicacoes-saibamais:hover{
        text-decoration: none;
    }
    .ultimas-publicacoes .ultimas-publicacoes-container .ultimas-publicacoes-card .ultimas-publicacoes-saibamais{
        text-align: left;
        font: normal normal normal 15px/20px 'Kanit', sans-serif;
        letter-spacing: 0px;
        color: #4780F1;
        text-transform: none;
        display: flex;
        align-items: center;
    }
    .ultimas-publicacoes .ultimas-publicacoes-container .ultimas-publicacoes-card .ultimas-publicacoes-saibamais .ultimas-publicacoes-saibamais-arrow{
        content: '';
        width: 20px;
        height: 1px;
        display: flex;
        background-color: #4780F1;
        align-items: center;
        justify-content: flex-end;
        margin-left: 12px;
    }
    .ultimas-publicacoes .ultimas-publicacoes-container .ultimas-publicacoes-card .ultimas-publicacoes-saibamais .ultimas-publicacoes-saibamais-arrow:after{
        content: '';
        border: solid #4780F1;
        border-width: 1px 1px 0 0;
        height: 6.5px;
        width: 6.5px;
        rotate: 45deg;
    }

    @media (max-width:1200px){
        .carousel-item {
            height: 525px !important;
            margin-right:calc(-100vw - 20px);
        }
        .ultimasPublicacoesCarousel-elements{width: fit-content;margin: 0 auto;}
            .ultimasPublicacoesCarousel-elements img{width: 320px;height: 186px;}
            .ultimasPublicacoesCarousel-elements h2{font: normal normal bold 20px/27px 'Kanit', sans-serif;color:#707070;max-width: 320px;padding-right: 33px;margin: 0 auto;text-align: start;text-transform: none;margin-bottom: 18px;}
            .ultimasPublicacoesCarousel-elements p{font: normal normal normal 15px/20px 'Kanit', sans-serif;color:#707070;max-width: 320px;padding-right: 22px;margin: 0 auto;text-align: start;text-transform: none;margin-bottom: 21px;max-height: 80px;overflow: hidden;position: relative;}
            .ultimasPublicacoesCarousel-elements p:before{content: "";text-align: right;position: absolute;bottom: 1px;right: 0;width: 100%;height: 40px;background: linear-gradient(to bottom, #f1f1f100 , #f1f1f1b8 100%);}
            .ultimasPublicacoesCarousel-elements a{font: normal normal normal 15px/20px 'Kanit', sans-serif;color:#4780F1;display: flex;justify-content: start;align-items: center;text-transform: none;}
            .ultimasPublicacoesCarousel-elements a::before{content: '';position:absolute;left:215px;margin-top:3px;background-color: #4780F1;width: 20px;height: 1px;}
            .ultimasPublicacoesCarousel-elements a::after{content: '';position:absolute;left:215px;margin-top:3px;margin-left: 13px;width: 7px;height: 7px;transform: rotate(45deg);border-right: 1px solid #4780F1;border-top: 1px solid #4780F1;}
                .ultimasPublicacoesCarousel-elements a:hover{color:#4780F1;text-decoration: none;}
        
    }
</style>